import { Navigation } from "@/components/holideviser/Navigation";
import { Hero } from "@/components/holideviser/Hero";
import { HowItWorks } from "@/components/holideviser/HowItWorks";
import { FeaturedDestinations } from "@/components/holideviser/FeaturedDestinations";
import { Discoverography } from "@/components/holideviser/Discoverography";
import { Manifesto } from "@/components/holideviser/Manifesto";
import { AiHuman } from "@/components/holideviser/AiHuman";
import { TravellerNotes } from "@/components/holideviser/TravellerNotes";
import { FaqSection } from "@/components/holideviser/FaqSection";
import { PlanTripCta } from "@/components/holideviser/PlanTripCta";
import { Footer } from "@/components/holideviser/Footer";

export const HomePage = () => {
  return (
    <div className="App min-h-screen bg-ink">
      <Navigation />
      <main>
        <Hero />
        <HowItWorks />
        <FeaturedDestinations />
        <Discoverography />
        <Manifesto />
        <AiHuman />
        <TravellerNotes />
        <FaqSection />
        <PlanTripCta />
      </main>
      <Footer />
    </div>
  );
};
